// Import all team images so Vite includes them in the build
import organizerAditya from "/images/team/organizer-aditya.jpg"
import organizerAlek from "/images/team/organizer-alek.jpg"
import organizerAllan from "/images/team/organizer-allan.jpg"
import organizerCamillaLarsen from "/images/team/organizer-camilla-larsen.jpg"
import organizerJinhongBrejnholt from "/images/team/organizer-jinhong-brejnholt.jpg"
import organizerKasperNissen from "/images/team/organizer-kasper-nissen.jpg"
import organizerMads from "/images/team/organizer-mads.jpg"
import organizerMertGungor from "/images/team/organizer-mert-gungor.jpg"
import organizerNikitaHald from "/images/team/organizer-nikita-hald.jpg"
import organizerOpheliaDalsgaard from "/images/team/organizer-ophelia-dalsgaard.jpg"
import organizerPerChristiansen from "/images/team/organizer-per-christiansen.jpg"
import organizerPlaceholder from "/images/team/organizer-placeholder-picture.jpg"
import organizerRene from "/images/team/organizer-rene.jpg"
import organizerRobertJensen from "/images/team/organizer-robert-jensen.jpg"
import organizerRyanGough from "/images/team/organizer-ryan-gough.jpg"
import organizerSoren from "/images/team/organizer-soren.jpg"
import organizerThomasVitale from "/images/team/organizer-thomas-vitale.jpg"
import organizerThorLange from "/images/team/organizer-thor-lange.jpg"

export const teamImages: Record<string, string> = {
  "team/organizer-aditya.jpg": organizerAditya,
  "team/organizer-alek.jpg": organizerAlek,
  "team/organizer-allan.jpg": organizerAllan,
  "team/organizer-camilla-larsen.jpg": organizerCamillaLarsen,
  "team/organizer-jinhong-brejnholt.jpg": organizerJinhongBrejnholt,
  "team/organizer-kasper-nissen.jpg": organizerKasperNissen,
  "team/organizer-mads.jpg": organizerMads,
  "team/organizer-mert-gungor.jpg": organizerMertGungor,
  "team/organizer-nikita-hald.jpg": organizerNikitaHald,
  "team/organizer-ophelia-dalsgaard.jpg": organizerOpheliaDalsgaard,
  "team/organizer-per-christiansen.jpg": organizerPerChristiansen,
  "team/organizer-placeholder-picture.jpg": organizerPlaceholder,
  "team/organizer-rene.jpg": organizerRene,
  "team/organizer-robert-jensen.jpg": organizerRobertJensen,
  "team/organizer-ryan-gough.jpg": organizerRyanGough,
  "team/organizer-soren.jpg": organizerSoren,
  "team/organizer-thomas-vitale.jpg": organizerThomasVitale,
  "team/organizer-thor-lange.jpg": organizerThorLange,
}
